import React from "react";

export default function TestimonialsDescription({ children }) {
  return <div className='testimonials-description'>{children}</div>;
}
